import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useHistory } from "react-router-dom";

import styled from "styled-components";

const ScrollStyle = styled.div`
  overflow: hidden visible;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #424b59;
  }

  h1 {
    font-size: 20px;
    font-weight: 500;
  }

  h2 {
    font-size: 17px;
    font-weight: 500;
  }

  h3 {
    font-size: 15px;
    font-weight: 400;
  }

  h4 {
    font-size: 12px;
    font-weight: 300;
  }

  a {
    color: var(--sensolus-ai-accent);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

interface SntMarkdownProps {
  text?: string;
  className?: string;
  height?: string | number;
}

const SntMarkdown = ({ text, className = "", height }: SntMarkdownProps) => {
  const history = useHistory();

  if (!text) return <></>;

  const handleLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href?: string
  ) => {
    e.preventDefault();
    e.stopPropagation();

    if (!href) return;

    // Check if it's an internal link (same origin or relative path)
    const isInternal =
      href.startsWith("/") ||
      href.startsWith(window.location.origin) ||
      (!href.startsWith("http://") &&
        !href.startsWith("https://") &&
        !href.startsWith("mailto:"));

    if (isInternal) {
      // Extract the path from the URL
      const path = href.startsWith(window.location.origin)
        ? href.substring(window.location.origin.length)
        : href;

      // Always push with a unique state to ensure navigation is detected
      // even when only query params change on the same route
      history.push(path, { navigationId: Date.now() });
    } else {
      // External link - open in new tab
      window.open(href, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <ScrollStyle style={{ height: height }}>
      <Markdown
        remarkPlugins={[remarkGfm]}
        className={className}
        components={{
          a: ({ href, ...props }) => {
            // Decode HTML entities in the href to handle &amp; -> &
            const decodedHref = href ? href.replace(/&amp;/g, "&") : href;
            return (
              <a
                href={decodedHref}
                onClick={(e) => handleLinkClick(e, decodedHref)}
                {...props}
              />
            );
          },
          // table: ({ node, ...props }) => (
          //   <table className="table table-bordered table-striped" {...props} />
          // ),
        }}
      >
        {text}
      </Markdown>
    </ScrollStyle>
  );
};

export default SntMarkdown;
